import { AiFillAppstore, AiOutlineUser } from "react-icons/ai";
import {
  FaBookOpen,
  FaBroadcastTower,
  FaCalendarAlt,
  FaCompactDisc,
  FaComments,
  FaCreditCard,
  FaHeadphones,
  FaImage,
  FaLaughBeam,
  FaMicrophoneAlt,
  FaMoneyBillWave,
  FaMusic,
  FaRegCalendarCheck,
  FaRegStar,
  FaTicketAlt,
  FaUsers,
} from "react-icons/fa";
import {
  MdAlbum,
  MdCategory,
  MdOutlineLibraryMusic,
  MdOutlineLocalActivity,
  MdPayment,
  MdQueueMusic,
  MdTrendingUp,
} from "react-icons/md";

const adminRoles = ["SuperAdmin", "Admin"];
const allRoles = [
  "SuperAdmin",
  "Admin",
  "Listener",
  "DJ",
  "Label",
  "Comedian",
  "Artist",
  "Producer",
];

export const adminLinks = [
  {
    route: "/app/dashboard",
    name: "Dashboard",
    Icon: AiFillAppstore,
    allowed: adminRoles,
  },
  {
    name: "Users & Access",
    Icon: FaUsers,
    allowed: adminRoles,
    children: [
      {
        route: "/app/users",
        name: "Users",
        Icon: FaUsers,
        allowed: adminRoles,
      },
      {
        route: "/app/profile",
        name: "Profile",
        Icon: AiOutlineUser,
        allowed: allRoles,
      },
    ],
  },
  {
    name: "Music Catalog",
    Icon: MdOutlineLibraryMusic,
    allowed: adminRoles,
    children: [
      {
        route: "/app/songs",
        name: "Songs",
        Icon: FaMusic,
        allowed: adminRoles,
      },
      {
        route: "/app/albums",
        name: "Albums",
        Icon: MdAlbum,
        allowed: adminRoles,
      },
      {
        route: "/app/beats",
        name: "Beats",
        Icon: FaCompactDisc,
        allowed: adminRoles,
      },
      {
        route: "/app/dj-mixes",
        name: "DJ Mixes",
        Icon: FaHeadphones,
        allowed: adminRoles,
      },
      {
        route: "/app/comedy",
        name: "Comedy",
        Icon: FaLaughBeam,
        allowed: adminRoles,
      },
      {
        route: "/app/genres",
        name: "Genres",
        Icon: MdCategory,
        allowed: adminRoles,
      },
      {
        route: "/app/playlists",
        name: "Playlists",
        Icon: MdQueueMusic,
        allowed: adminRoles,
      },
    ],
  },
  {
    name: "Engagement",
    Icon: FaBroadcastTower,
    allowed: adminRoles,
    children: [
      {
        route: "/app/streams",
        name: "Streams",
        Icon: FaBroadcastTower,
        allowed: adminRoles,
      },
      {
        route: "/app/trending",
        name: "Trending",
        Icon: MdTrendingUp,
        allowed: adminRoles,
      },
      {
        route: "/app/history",
        name: "Listening History",
        Icon: FaBookOpen,
        allowed: adminRoles,
      },
      {
        route: "/app/chats",
        name: "Chats",
        Icon: FaComments,
        allowed: adminRoles,
      },
    ],
  },
  {
    name: "Events & Booking",
    Icon: FaCalendarAlt,
    allowed: adminRoles,
    children: [
      {
        route: "/app/events",
        name: "Events",
        Icon: FaCalendarAlt,
        allowed: adminRoles,
      },
      {
        route: "/app/bookings",
        name: "Bookings",
        Icon: FaRegCalendarCheck,
        allowed: adminRoles,
      },
      {
        route: "/app/competitions",
        name: "Competitions",
        Icon: FaRegStar,
        allowed: adminRoles,
      },
    ],
  },
  {
    name: "Payments",
    Icon: MdPayment,
    allowed: adminRoles,
    children: [
      {
        route: "/app/payments/events",
        name: "Event Payments",
        Icon: FaTicketAlt,
        allowed: adminRoles,
      },
      {
        route: "/app/payments/beats",
        name: "Beat Payments",
        Icon: FaMoneyBillWave,
        allowed: adminRoles,
      },
      {
        route: "/app/payments/competitions",
        name: "Competition Payments",
        Icon: FaCreditCard,
        allowed: adminRoles,
      },
    ],
  },
  {
    name: "Platform Content",
    Icon: MdOutlineLocalActivity,
    allowed: adminRoles,
    children: [
      {
        route: "/app/banners",
        name: "Banners",
        Icon: FaImage,
        allowed: adminRoles,
      },
      {
        route: "/app/services",
        name: "Services",
        Icon: FaMicrophoneAlt,
        allowed: adminRoles,
      },
    ],
  },
];

export const csuLinks = adminLinks;
export const hopLinks = adminLinks;
